import { Link } from 'react-router-dom';
import './Referrals.css';

function Referrals() {
  return (
    <section className="referrals-page">
      <div className="referrals-hero">
        <p className="referrals-eyebrow">BESC Referrals</p>
        <h1>Earn from every bridge you refer.</h1>
        <p className="referrals-subtitle">
          The referral program is coming soon. You will earn from users you bring to
          BESC Bridge and CrossPort with tracked payouts and a clean dashboard.
        </p>
        <div className="referrals-actions">
          <Link to="/besc-bridge" className="button primary" aria-label="Open BESC Bridge">
            Open BESC Bridge
          </Link>
          <Link to="/crossport" className="button ghost" aria-label="Open CrossPort">
            Launch CrossPort
          </Link>
        </div>
      </div>

      <div className="referrals-grid">
        <article className="referrals-card">
          <h3>Coming soon</h3>
          <p>
            We are finalizing the referral tracking and payout engine so rewards are
            accurate and instant.
          </p>
          <span>Targeting early access for partners and community leaders.</span>
        </article>
        <article className="referrals-card">
          <h3>How it will work</h3>
          <ul>
            <li>Share a referral link tied to your wallet.</li>
            <li>Users bridge with BESC Bridge or CrossPort.</li>
            <li>Earn a percentage from each successful transfer.</li>
          </ul>
        </article>
        <article className="referrals-card">
          <h3>What you will see</h3>
          <ul>
            <li>Realtime referral dashboard and totals.</li>
            <li>Breakdown by chain, token, and volume.</li>
            <li>Payout history with on-chain receipts.</li>
          </ul>
        </article>
      </div>
    </section>
  );
}

export default Referrals;
